import { useClaims } from "../auth/useClaims";

type GuardProps = {
  allowedGroups: string[];
  children: React.ReactNode;
};

export function GroupGuard({ allowedGroups, children }: GuardProps) {
  const { groups, isReady } = useClaims();

  // Enquanto não carregou claims → mostra loading
  if (!isReady) {
    return (
      <div className="flex flex-col items-center justify-center h-screen text-slate-600 gap-4">
        <div className="h-10 w-10 border-4 border-slate-300 border-t-slate-600 rounded-full animate-spin"></div>
        <p className="text-lg font-semibold">Validando acesso...</p>
      </div>
    );
  }

  const hasAccess = allowedGroups.some((g) => groups.includes(g));

  if (!hasAccess) {
  return (
    <div className="flex items-center justify-center h-screen bg-slate-50">
      <div className="max-w-md w-full bg-white shadow-xl rounded-2xl p-8 text-center border border-red-300">
        <div className="flex items-center justify-center w-16 h-16 mx-auto rounded-full bg-red-100 mb-4">
          <svg
            className="w-8 h-8 text-red-600"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01M12 19c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7z" />
          </svg>
        </div>
        <h2 className="text-xl font-bold text-red-700 mb-2">Acesso Negado</h2>
        <p className="text-slate-600">
          Você não possui permissão para acessar esta página.  
          Caso acredite que seja um engano, entre em contato com o administrador.
        </p>
      </div>
    </div>
  );
}

  return <>{children}</>;
}
